import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const { Option } = Select;

const SelectCity = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);

  const fetchOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/get_cities/`);
      setOptions(response.data);
    } catch (error) {
      console.error('Failed to fetch options:', error);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  const dropdownStyle = {
    minWidth: '300px', // Set your desired width here
  };

  return (
    <Select
      showSearch
      placeholder="输入搜索城市"
      optionFilterProp="children"
      onClick={fetchOptions}
      onChange={onChange}
      filterOption={(input, option) =>
        option.children.toLowerCase().includes(input.toLowerCase())
      }
      dropdownStyle={dropdownStyle} // Apply custom width directly to the dropdown
      value={value} // Set the initial value
    >
      {options.map((city) => (
        <Option key={city.code} value={city.label}>
          {city.city}
        </Option>
      ))}
    </Select>
  );
};

export default SelectCity;
